import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, PropType, ref } from 'vue'
import { ILeftTab } from './type'


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftTabsLayout',
  props: {
  // 默认显示那个 tab
  defaultTab: {
    type: String
  },
  /**
   * true: tab 之间 v-show
   * false: tab 之间 v-if
   */
  keepAlive: {
    type: Boolean
  },
  // 包含那些tabs
  tabs: {
    type: Array as PropType<ILeftTab[]>,
    default: () => [],
    validator: (val: ILeftTab[]) => {
      const names = val.map(i => i.name)
      if(!names.every(i => !!i)) {
        throw Error('tabs 中name 不能为空')
      }
      if(names.length !== new Set(names).size) {
        throw Error('tabs 中name 不能重复')
      }
      return true
    }
  },
  // 点击切换tab 前，可通过返回 Promise.reject() 阻止切换
  beforeSwitchTab: {
    type: Function as PropType<(tab: ILeftTab) => Promise<void>>
  }
},
  emits: ['change-tab'],
  setup(__props, { expose, emit: emits }) {

const props = __props




const currentTab = ref<string>()

onBeforeMount(() => {
  currentTab.value = props.defaultTab
})

function setTab(name: string) {
  currentTab.value = name
  emits('change-tab', name)
}

function switchTab(tab: ILeftTab) {
  if (props.beforeSwitchTab) {
    props.beforeSwitchTab(tab).then(() => setTab(tab.name))
  } else {
    setTab(tab.name)
  }
}

expose({
  setTab,
})


return { __sfc: true,props, emits, currentTab, setTab, switchTab }
}

})